import { createSlice } from "@reduxjs/toolkit";

export const dashboardFilter = createSlice({
  name: "dashboard-filter",
  initialState: {
    value: {
      filter: {
        dropdownFilter: {
          cnpjArray: [],
          estateArray: [],
          fieldFilter: false,
        },
      },
      ticketFilter: { chipFilter: [], fieldFilter: "" },
      data: {
        equip: [],
        ticket: [],
        equipmentNotPreScheduled: [],
        equipmenPreScheduled: [],
      },
      OCCFiles: [],
      EquipModels: [],
    },
  },
  reducers: {
    getDropdownFilterCnpj(state, { payload }) {
      state.value.filter.dropdownFilter.cnpjArray = payload;
    },
    getDropdownFilterEstate(state, { payload }) {
      state.value.filter.dropdownFilter.estateArray = payload;
    },

    getFieldFilter(state, { payload }) {
      state.value.filter.dropdownFilter.fieldFilter = payload;
    },

    updateTicketFieldFilter(state, { payload }) {
      state.value.ticketFilter.fieldFilter = payload;
    },

    updateDropdownFilterCnpj(state, { payload }) {
      state.value.filter.dropdownFilter.cnpjArray =
        state.value?.filter?.dropdownFilter?.cnpjArray?.filter(item => {
          return item !== payload;
        });
    },
    updateDropdownFilterEstate(state, { payload }) {
      state.value.filter.dropdownFilter.estateArray =
        state.value.filter.dropdownFilter.estateArray.filter(item => {
          return item !== payload;
        });
    },

    updateEquipment(state, { payload }) {
      state.value.data.equip = payload;
    },

    updateTicket(state, { payload }) {
      state.value.data.ticket = payload;
    },

    updateEquipementNotPreScheduled(state, { payload }) {
      if (Array.isArray(payload)) {
        payload.forEach(element => {
          state.value.data.equipmentNotPreScheduled.push(element);
        });
      } else {
        state.value.data.equipmentNotPreScheduled.push(payload);
      }

      let newArray = state.value.data.equipmentNotPreScheduled.filter(
        e => e !== null
      );
      state.value.data.equipmentNotPreScheduled = Array.from(new Set(newArray));
    },

    updateEquipmentPreScheduled(state, { payload }) {
      state.value.data.equipmenPreScheduled = payload;
    },

    updateOCCFiles(state, { payload }) {
      console.log("Occ files " + state.value.OCCFiles.length);
      state.value.OCCFiles = payload;
    },

    updateEquipModel(state, { payload }) {
      console.log("Equip models " + state.value.EquipModels.length);
      state.value.EquipModels.push(payload);
    },
  },
});

export const {
  updateDropdownFilter,
  getDropdownFilterCnpj,
  getDropdownFilterEstate,
  updateTicketFieldFilter,
  updateDropdownFilterCnpj,
  updateDropdownFilterEstate,
  updateEquipment,
  updateTicket,
  updateEquipementNotPreScheduled,
  updateEquipmentPreScheduled,
  updateOCCFiles,
  updateEquipModel,
  getFieldFilter,
} = dashboardFilter.actions;

export default dashboardFilter.reducer;
